import { useThemeContext } from './ThemeProvider'
import { Moon, Sun, Monitor } from 'lucide-react'

interface ThemeToggleProps {
  className?: string
}

export default function ThemeToggle({ className = '' }: ThemeToggleProps) {
  const { theme, setLightMode, setDarkMode, setSystemMode } = useThemeContext()

  const getThemeIcon = () => {
    switch (theme) {
      case 'dark':
        return <Moon size={16} />
      case 'light':
        return <Sun size={16} />
      default:
        return <Monitor size={16} />
    }
  }

  const getThemeLabel = () => {
    switch (theme) {
      case 'dark':
        return 'Dark Mode'
      case 'light':
        return 'Light Mode'
      default:
        return 'System Mode'
    }
  }

  return (
    <div className={`space-y-2 ${className}`}>
      {/* Current theme display */}
      <div className="flex items-center gap-2 px-2 py-1 text-sm text-gray-600 dark:text-gray-300">
        {getThemeIcon()}
        <span>{getThemeLabel()}</span>
      </div>

      {/* Theme options */}
      <div className="space-y-1">
        <button
          onClick={setLightMode}
          className={`flex items-center gap-3 w-full px-3 py-2 text-sm rounded-md transition-colors ${
            theme === 'light'
              ? 'bg-primary-50 text-primary-700 dark:bg-primary-900/20 dark:text-primary-300'
              : 'text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700'
          }`}
        >
          <Sun size={16} />
          <span>Light</span>
        </button>

        <button
          onClick={setDarkMode}
          className={`flex items-center gap-3 w-full px-3 py-2 text-sm rounded-md transition-colors ${
            theme === 'dark'
              ? 'bg-primary-50 text-primary-700 dark:bg-primary-900/20 dark:text-primary-300'
              : 'text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700'
          }`}
        >
          <Moon size={16} />
          <span>Dark</span>
        </button>

        <button
          onClick={setSystemMode}
          className={`flex items-center gap-3 w-full px-3 py-2 text-sm rounded-md transition-colors ${
            theme === 'system'
              ? 'bg-primary-50 text-primary-700 dark:bg-primary-900/20 dark:text-primary-300'
              : 'text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700'
          }`}
        >
          <Monitor size={16} />
          <span>System</span>
        </button>
      </div>
    </div>
  )
}